type CheckboxCheckedProps = {
  className?: string;
};

const CheckboxChecked = ({ className }: CheckboxCheckedProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="1" y="1" width="22" height="22" rx="3" fill="#1C7B7C" />
    <rect
      x="1"
      y="1"
      width="22"
      height="22"
      rx="3"
      stroke="#1C7B7C"
      strokeWidth="2"
    />
    <path
      d="M9.55363 15.15L18.0286 6.675C18.2286 6.475 18.462 6.375 18.7286 6.375C18.9953 6.375 19.2286 6.475 19.4286 6.675C19.6286 6.875 19.7286 7.1125 19.7286 7.3875C19.7286 7.6625 19.6286 7.9 19.4286 8.1L10.2536 17.3C10.0536 17.5 9.82029 17.6 9.55363 17.6C9.28696 17.6 9.05363 17.5 8.85363 17.3L4.55363 13C4.35363 12.8 4.25779 12.5625 4.26613 12.2875C4.27446 12.0125 4.37863 11.775 4.57863 11.575C4.77863 11.375 5.01613 11.275 5.29113 11.275C5.56613 11.275 5.80362 11.375 6.00362 11.575L9.55363 15.15Z"
      fill="white"
    />
  </svg>
);

export default CheckboxChecked;
